import {isDev} from "./is-dev";

export function getBaseUrl() {
    return isDev() ? "http://localhost:8788/" : "";
}

export function getGeneratePaymentLinkApiUrl() {
    const baseUrl = getBaseUrl();
    return `${baseUrl}api/generate-payment-link`;
}